import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';

import {Button, List, ListItem, ListItemAvatar, Dialog, Typography} from '@material-ui/core';
import MeetingBreakIcon from './Icons/MeetingBreakIcon';
import useStyles from './styles';
import Stopwatch from './Timer';

//store
import * as actions from '../../store/actions/actionIndex';

import {localStorageFunc} from '../../helpers/utility';
import { useLoader } from '../../context/LoaderContext';
import Loading from '../../pages/Loading';

function Break(props) {
  var classes = useStyles();
  const [open, setOpen] = useState(false);
  const componentId = 'BreakCondition';
  const {loading, showLoader} = useLoader(componentId);

  const {agentState, breakType, agentInConf, readyFlag} = props;
 
  useEffect(
    () => {
      if(readyFlag === "1" && agentState!=="BREAK" && breakType !== 'JoinedConference' && !agentInConf ){
      }
      else if ((agentState === 'BREAK' || agentState === 'READY') && breakType !== 'JoinedConference' && !agentInConf) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    },
    [agentState, breakType, agentInConf, readyFlag],
    []
  );
  // console.log(loading);
  const handleClose = () => {
    setOpen(false);
  };

  const handleBreak = () => {
  showLoader();
    props.onAgentBreak(props.agentId, props.agentState === 'READY' ? 'READY' : 'FREE', props.breakType);
    localStorageFunc.set('autoBreakFlag', 'autoBreakFlag', 10);
    localStorageFunc.set('autoReadyFlag', 'autoReadyFlag', 10);
    //localStorageFunc.erase('autoReadyFlag');
    clearTimeout(window.autoBreakAction);
    clearTimeout(window.autoReadyAction);
  };
  const formatBreakType = (text) => {
  if (!text) return '';
  return text
    .replace(/([a-z])([A-Z])/g, '$1 $2')   
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') 
    .trim();
};

  return (
    <div className='transfer-dropdown'>
      <Dialog className={classes.dialog} fullWidth onClose={handleClose} aria-labelledby='simple-dialog-title' open={open}>
        <List>
          <Typography className={classes.dialogTital}>
            You are currently in{' '}
            <font fontSize='0.8rem' color='blue'>
              <b>
                {formatBreakType(props.breakType)}
                {props.agentState === 'READY' ? 'Ready State' : props.breakType.toLowerCase() !== 'break' ? ' break' : ''}
              </b>
            </font>
          </Typography>
          <Typography className={classes.dialogTital}>
            Allowed Time
            <font fontSize='0.8rem' color='blue'>
              <b>{props.agentState === 'READY' ? (props.autoReadyTime === '0' ? '00:00:00' : new Date(parseInt(props.autoReadyTime) * 1000).toISOString().substr(11, 8)) : props.allowedTime === '0' ? '00:00:00' : props.allowedTime}</b>
            </font>{' '}
          </Typography>
          <ListItem style={{justifyContent: 'center'}}>
            <ListItemAvatar className={classes.avatar}>
              <MeetingBreakIcon />
            </ListItemAvatar>
            <Typography style={{display: 'flex', paddingTop: '77px', paddingInlineStart: '0px '}} className={classes.callerName}>
              <Stopwatch />
            </Typography>
          </ListItem>
          <div className='loding-center'>
          {loading ? <Loading/> : 
          <Button variant='contained' className={classes.callButton} style={{backgroundColor: '#526FEB'}} onClick={() => handleBreak()}  disabled={loading}>
            Resume
          </Button>
          }
          {/* <Button variant='contained' className={classes.callButton} style={{backgroundColor: '#526FEB'}} onClick={() => handleBreak()}>
            Resume 
          </Button> */}
          </div>
        </List>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    allowedTime: state.agentData.allowedTime,
    autoReadyTime: state.agentData.autoReadyTime,
    breakType: state.agentData.breakType,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    agentInConf: state.agentData.agentInConf,
    readyFlag: state.agentData.autoReadyFlag
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentBreak: (agentId, breakState, reason) => dispatch(actions.agentBreak(agentId, breakState, reason)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Break);
